import style from './PendingElement.module.scss';
import "../../../../index.scss";
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import Question from "../../../../assets/images/question-mark.svg";
import { useAppDispatch, useAppSelector, useIsLoggedSelector } from '../../../../services/hooks.service';
import { ReactComponent as PEND } from "../../../../assets/images/pending.svg";
import { ModalApp } from '../../ModalApp/ModalApp';
import { ACTION_TYPE, IPendingTxn } from '../../../../interfaces';
import { amountFormate, equalsIgnoreCase } from '../../../../_utils';
import { ImageWithFallback } from '../../ImageWithFallback/ImageWithFallback';
import { ROUTES } from '../../../../hooks';
import { getLogo } from '../../../../wallets/providers';
import { savePendingTxnsCount } from '../../../../redux/_actions/exchange.action';
import { initialExchangeAssetsState, useGetCodexAssetsQuery, useLazyGetPendingTransactionsQuery } from '@ultrade/react-sdk';

interface PendingActions {
  deposit?: IPendingTxn[], 
  withdraw?: IPendingTxn[], 
  transfer?: IPendingTxn[]
}

export const PendingElement = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isLogged = useIsLoggedSelector();
  const mainAddress = useAppSelector((state) => state.user.mainAddress);
  const sdkClient = useAppSelector((state) => state.sdkClient.instance);
  const pendingCount = useAppSelector((state) => state.exchange.pendingTxnsCount);
  // const assets = useAppSelector((state) => state.exchange.exchangeAssets);
  // const rtkSdkClient = useAppSelector((state) => state.rtkSdkClient.instance);
  
  const [pendingTxns, setPendingTxns] = useState<PendingActions>({ deposit: [], withdraw: [], transfer: [] });
  const [modal, setModal] = useState(false);

  const {data: assets = initialExchangeAssetsState} = useGetCodexAssetsQuery(undefined);
  const [getPendingTransactionsQuery] = useLazyGetPendingTransactionsQuery();

  const navigateTo = (type: ACTION_TYPE) => {
    const state = equalsIgnoreCase(type, ACTION_TYPE.D)
    ? { manageTxnD: true } 
    : equalsIgnoreCase(type, ACTION_TYPE.W)
      ? { manageTxnW: true } 
      : { manageTxnT: true };
    navigate(ROUTES.account, { state });
    setModal(false);
  }

  const renderModalRow = useCallback((item: IPendingTxn, index: number) => {
    const asset = assets.find((asset) => asset.id === item.tokenId);
    if (!asset) return <></>;

    return (
    <div className={style.modal_row}>
      <span>
        <span className={style.gray_txt}>{ index +1 }. { t("comman_word.token") }:</span>
        <span>
          <ImageWithFallback src={getLogo(asset.chainId)} fallbackSrc={Question} alt="asset icon" className={style.asset_img} /> 
          { asset.unit_name }
        </span>
      </span>
      <span>
        <span className={style.gray_txt}>{ t("comman_word.amount") }:</span> 
        { amountFormate(item.amount, asset.decimal, 6) }
      </span>
    </div>
  )}, [assets.length]);

  const handleClick = () => {
    setModal(true);
    getPendingTransactions();
  }

  const getPendingTransactions = async () => {
    try {
      const txns = await getPendingTransactionsQuery().unwrap() as any;
      if (txns.length) {
        const pendingObject = txns.reduce((acc, el) => {
          acc[el.type] 
            ? acc[el.type].push(el) 
            : acc[el.type] = [el];
          return acc;
        }, {});
        setPendingTxns(pendingObject);
        dispatch(savePendingTxnsCount(txns.length));
      }
    } catch (e) {
      console.log("ERROR on get pending txns", e)
    }
  }

  useEffect(() => {
    if (!mainAddress) return;
    getPendingTransactions();
  }, [mainAddress]);

  return (
    <> 
      { !!pendingCount && <>
        <button className={style.pending_cont} onClick={handleClick}>
          <span className={style.pending_bg}/>
          <span className={style.pending_txt}>
            { t("openHistory.pending") }
            <span className={style.pending_img}>
              <PEND />
            </span>
          </span>
          <span className={style.txns_count}>
            { pendingCount > 99 ? "99+" : pendingCount }
          </span>
        </button>

        <ModalApp 
          show={modal} 
          width={330} 
          onHide={() => setModal(false)}
          title={t("account_history.pending_transactions", { count: pendingCount })}
        >
          <div className={style.modal_cont}>
            { !!pendingTxns.deposit?.length && <>
              <p>{ t("account_history.deposits_history") }</p>
              <p>{ pendingTxns.deposit.map((item, ind) => renderModalRow(item, ind)) }</p>
              <button 
                className={classNames("transparent_btn", style.modal_btn)}
                onClick={() => navigateTo(ACTION_TYPE.D)}
              >
                { t("account_history.view_deposit_details") }
              </button>
            </>}

            { !!pendingTxns.withdraw?.length && <>
              <p>{ t("account_history.withdrawals_history") }</p>
              <p>{ pendingTxns.withdraw.map((item, ind) => renderModalRow(item, ind)) }</p>
              <button 
                className={classNames("transparent_btn", style.modal_btn)}
                onClick={() => navigateTo(ACTION_TYPE.W)}
              >
                { t("account_history.view_withdrawal_details") }
              </button>
            </>}

            { !!pendingTxns.transfer?.length && <>
              <p>{ t("account_history.transfers_history") }</p>
              <p>{ pendingTxns.transfer.map((item, ind) => renderModalRow(item, ind)) }</p>
              <button
                className={classNames("transparent_btn", style.modal_btn)}
                onClick={() => navigateTo(ACTION_TYPE.T)}
              >
                { t("account_history.view_transfer_details") }
              </button>
            </>}
          </div>
        </ModalApp>
      </> }
    </>
  );
};
